import './styles.css'

function AIAssistantSettings({ dataType, onDataTypeChange }) {
  return (
    <div className="ai-assistant-settings">
      <p className="ai-assistant-instruction">
        Selecciona los datos a analizar, a continuación, selecciona el periodo, los datos a explotar y el tipo de gráfico.
      </p>
      <div className="ai-assistant-section">
        <h3 className="ai-assistant-section-title">Tipo de Datos</h3>
        <div className="ai-assistant-options">
          <label className="ai-radio-card">
            <input
              type="radio"
              name="dataType"
              value="usuarios"
              checked={dataType === 'usuarios'}
              onChange={(e) => onDataTypeChange(e.target.value)}
            />
            <span className="ai-radio-label">Usuarios</span>
          </label>
          <label className="ai-radio-card">
            <input
              type="radio"
              name="dataType"
              value="autorizaciones"
              checked={dataType === 'autorizaciones'}
              onChange={(e) => onDataTypeChange(e.target.value)}
            />
            <span className="ai-radio-label">Autorizaciones</span>
          </label>
          <label className="ai-radio-card">
            <input
              type="radio"
              name="dataType"
              value="capturas"
              checked={dataType === 'capturas'}
              onChange={(e) => onDataTypeChange(e.target.value)}
            />
            <span className="ai-radio-label">Capturas</span>
          </label>
          <label className="ai-radio-card">
            <input
              type="radio"
              name="dataType"
              value="cupos"
              checked={dataType === 'cupos'}
              onChange={(e) => onDataTypeChange(e.target.value)}
            />
            <span className="ai-radio-label">Cupos</span>
          </label>
        </div>
      </div>
    </div>
  )
}

export default AIAssistantSettings
